export function truncateString(value: string, length: number): string {
	if (value?.length < length) {
		return value;
	}

	return value.slice(0, length);
}
